


















import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'NavigationDrawerUser',

  computed: {
    ...mapGetters('user', [
      'getUser',
    ]),

    image() {
      if (this.getUser.image && this.getUser.image.length > 0) {
        return this.getUser.image;
      }
      return 'https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg';
    },
  },
});
